import React from "react";
import Overview from "../components/myAreaPage/Overview";

export default function MyAreaPage(): JSX.Element {
  return <Overview />;
}
